import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Grid, Stack, Typography } from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import SchoolIcon from '@mui/icons-material/School';
import HandshakeIcon from '@mui/icons-material/Handshake';
import BusinessIcon from '@mui/icons-material/Business';

const roles = [
  {
    title: 'Player',
    description: 'Track skills, enter contests and compare with peers.',
    icon: <PersonAddIcon />,
    color: '#1976d2',
    path: '/register/player',
  },
  {
    title: 'Coach',
    description: 'Manage students, rankings and academy growth.',
    icon: <SchoolIcon />,
    color: '#7c3aed',
    path: '/register/coach',
  },
  {
    title: 'Academy',
    description: 'Register your school or sports academy on the platform.',
    icon: <BusinessIcon />,
    color: '#0d9488',
    path: '/register/academy',
  },
  {
    title: 'Sponsor',
    description: 'Partner on contests, training content and brand visibility.',
    icon: <HandshakeIcon />,
    color: '#ea580c',
    path: '/register/sponsor',
  },
];

const LandingConvertSection: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        mt: 6,
        p: { xs: 3, md: 4 },
        borderRadius: 4,
        background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #1d4ed8 100%)',
        color: '#fff',
        boxShadow: '0 24px 64px rgba(15, 23, 42, 0.25)',
      }}
    >
      <Typography variant="h4" sx={{ fontWeight: 900, mb: 0.5, textAlign: 'center' }}>
        Join EncycGames
      </Typography>
      <Typography variant="body1" sx={{ textAlign: 'center', color: 'rgba(255,255,255,0.8)', mb: 3, maxWidth: 560, mx: 'auto' }}>
        Players, coaches, academies and sponsors — pick your path and get started in minutes.
      </Typography>

      <Grid container spacing={2}>
        {roles.map((role) => (
          <Grid item xs={12} sm={6} md={3} key={role.title}>
            <Box
              sx={{
                p: 2,
                height: '100%',
                borderRadius: 2.5,
                bgcolor: 'rgba(255,255,255,0.08)',
                border: '1px solid rgba(255,255,255,0.12)',
                backdropFilter: 'blur(8px)',
              }}
            >
              <Box sx={{ color: role.color, mb: 1, display: 'flex' }}>{role.icon}</Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 800, mb: 0.5 }}>
                {role.title}
              </Typography>
              <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.75)', mb: 2, minHeight: 40 }}>
                {role.description}
              </Typography>
              <Button
                fullWidth
                variant="outlined"
                onClick={() => navigate(role.path)}
                sx={{
                  textTransform: 'none',
                  fontWeight: 700,
                  color: '#fff',
                  borderColor: 'rgba(255,255,255,0.35)',
                  '&:hover': { borderColor: '#fff', bgcolor: 'rgba(255,255,255,0.1)' },
                }}
              >
                Register
              </Button>
            </Box>
          </Grid>
        ))}
      </Grid>

      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} justifyContent="center" sx={{ mt: 3 }}>
        <Button
          variant="contained"
          size="large"
          onClick={() => navigate('/login')}
          sx={{ textTransform: 'none', fontWeight: 800, bgcolor: '#fff', color: '#0f172a', '&:hover': { bgcolor: '#f1f5f9' } }}
        >
          Sign in
        </Button>
        <Button
          variant="text"
          size="large"
          onClick={() => navigate('/team')}
          sx={{ textTransform: 'none', fontWeight: 700, color: '#e2e8f0' }}
        >
          Contact our team
        </Button>
      </Stack>
    </Box>
  );
};

export default LandingConvertSection;
